var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v(
          " Olá! No Monitoramento do Desempenho Comportamental você encontra três abas: "
        ),
      ]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" 1. "),
            _c("b", [_vm._v("Resultado dos servidores")]),
            _c("br"),
            _vm._v(" 2. "),
            _c("b", [_vm._v("Relatórios Gerenciais")]),
            _c("br"),
            _vm._v(" 3. "),
            _c("b", [_vm._v("Relatórios Gerenciais por unidades")]),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v(" 1. Resultado dos servidores ")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" Na aba "),
            _c("b", [_vm._v("“Resultado dos servidores”")]),
            _vm._v(" você encontra dois tipos de filtros: "),
            _c("br"),
            _vm._v(" 1. "),
            _c("b", [_vm._v("Unidade")]),
            _c("br"),
            _vm._v(" 2. "),
            _c("b", [_vm._v("Servidores avaliados")]),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" No filtro "),
            _c("b", [_vm._v("“Unidade”")]),
            _vm._v(
              " você pode selecionar qualquer unidade hierarquicamente vinculada a sua. E no filtro "
            ),
            _c("b", [_vm._v("“Servidores avaliados”")]),
            _vm._v(
              ", você encontra os membros da equipe da unidade selecionada. Ao selecionar um servidor, é possível analisar, por meio de gráficos e tabelas, os dados referentes ao desempenho comportamental do servidor selecionado, no ano em análise. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(" 1. Resultado dos servidores"),
        _c("br"),
        _vm._v(" Gráficos e tabelas "),
      ]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na primeira tabela são apresentadas as duas competências comportamentais identificadas como talentos do servidor selecionado e as duas mais indicadas para desenvolvimento. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " O velocímetro expressa o resultado obtido pelo servidor após a etapa diagnóstico comportamental, utilizando a ponderação: "
            ),
          ]
        ),
        _c(
          "p",
          {
            staticClass: "mx-2 pa-2 text-center font-weight-medium text-lg-h6",
          },
          [
            _vm._v(" 40% (autoavaliação) + 60% (nota gestor)"),
            _c("br"),
            _vm._v(
              " Quando há nota da equipe, a ponderação é feita da seguinte forma:"
            ),
            _c("br"),
            _vm._v(
              " 20% (autoavaliação) + 40% (nota gestor) + 40% (nota da equipe) "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(" 1. Resultado dos servidores"),
        _c("br"),
        _vm._v(" Gráficos e tabelas "),
      ]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na segunda tabela é possível observar as doze competências comportamentais e expandir cada competência para observar os comportamentos que a compõem. Prezando pela transparência dos dados, as colunas apresentam as notas alcançadas na autoavaliação, na avaliação do gestor e na avaliação da equipe (quando houver). A tabela apresenta ainda nota máxima a ser alcançada em cada competência e a coluna resultado, que utiliza a ponderação: "
            ),
          ]
        ),
        _c(
          "p",
          {
            staticClass: "mx-2 pa-2 text-center font-weight-medium text-lg-h6",
          },
          [
            _vm._v(" 40% (autoavaliação) + 60% (nota gestor)"),
            _c("br"),
            _vm._v(
              " Quando há nota da equipe, a ponderação é feita da seguinte forma:"
            ),
            _c("br"),
            _vm._v(
              " 20% (autoavaliação) + 40% (nota gestor) + 40% (nota da equipe) "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Para melhor interagir com a tabela, pode-se ainda utilizar os recursos de ordenação de forma crescente ou decrescente por: responsabilidade, notas, competências técnicas, além de permitir a pesquisa por qualquer termo exibido na tabela. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(" 2. Relatórios gerenciais"),
        _c("br"),
        _vm._v(" Gráficos e tabelas "),
      ]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" Na aba "),
            _c("b", [_vm._v("“Relatórios gerenciais”")]),
            _vm._v(", você encontra o filtro "),
            _c("b", [_vm._v("“Unidade”")]),
            _vm._v(
              ", onde pode selecionar mais de uma unidade. Ao escolher várias unidades, é possível analisar, por meio de gráficos e tabelas, dados conjuntos das unidades selecionadas. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na primeira tabela são apresentadas as duas competências comportamentais identificadas como talentos das unidades selecionadas e as duas mais indicadas para o desenvolvimento. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " O velocímetro expressa o resultado médio obtido pelos servidores das unidades selecionadas utilizando a ponderação: "
            ),
          ]
        ),
        _c(
          "p",
          {
            staticClass: "mx-2 pa-2 text-center font-weight-medium text-lg-h6",
          },
          [
            _vm._v(" 40% (autoavaliação) + 60% (nota gestor)"),
            _c("br"),
            _vm._v(
              " Quando há nota da equipe, a ponderação é feita da seguinte forma:"
            ),
            _c("br"),
            _vm._v(
              " 20% (autoavaliação) + 40% (nota gestor) + 40% (nota da equipe) "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(" 2. Relatórios gerenciais"),
        _c("br"),
        _vm._v(" Gráficos e tabelas "),
      ]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na segunda tabela é possível observar as doze competências comportamentais e expandir cada competência para observar os resultados médios das unidades selecionadas em cada uma delas. Prezando pela transparência dos dados, as colunas apresentam os resultados máximos, a média da unidade e o desvio padrão de cada competência. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Para melhor interagir com a tabela, pode-se ainda utilizar os recursos de ordenação de forma crescente ou decrescente por: competência, resultado máximo, média e desvio padrão, além de permitir a pesquisa por qualquer termo exibido na tabela. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v(" 3. Relatórios gerenciais por unidade ")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" Na aba "),
            _c("b", [_vm._v("“Relatórios gerenciais por unidade”")]),
            _vm._v(", você encontra o filtro "),
            _c("b", [_vm._v("“Unidade”")]),
            _vm._v(
              ". Ao selecionar uma unidade, é possível analisar, por meio de gráficos e tabelas, dados conjuntos da unidade selecionada. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na primeira tabela são apresentadas as duas competências comportamentais identificadas como talentos da unidade selecionada e as duas mais indicadas para o desenvolvimento. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " O velocímetro expressa o resultado conjunto obtido pelos servidores da unidade selecionada após a etapa diagnóstico comportamental utilizando a ponderação: "
            ),
          ]
        ),
        _c(
          "p",
          {
            staticClass: "mx-2 pa-2 text-center font-weight-medium text-lg-h6",
          },
          [
            _vm._v(" 40% (autoavaliação) + 60% (nota gestor)"),
            _c("br"),
            _vm._v(
              " Quando há nota da equipe, a ponderação é feita da seguinte forma:"
            ),
            _c("br"),
            _vm._v(
              " 20% (autoavaliação) + 40% (nota gestor) + 40% (nota da equipe) "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(" 3. Relatórios gerenciais por unidade"),
        _c("br"),
        _vm._v(" Tabelas "),
      ]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na segunda tabela é possível observar as doze competências comportamentais e expandir cada competência para observar os resultados dos servidores em cada uma delas. Prezando pela transparência dos dados, as colunas apresentam os resultados máximos, a média da unidade e o desvio padrão de cada competência. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Para melhor interagir com a tabela, pode-se ainda utilizar os recursos de ordenação de forma crescente ou decrescente por: competência, resultado máximo, média e desvio padrão, além de permitir a pesquisa por qualquer termo exibido na tabela. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("div", { staticClass: "mx-2 pa-2 justify-center" }, [
        _c("ul", [
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(" Recomenda-se visitar a aba "),
                _c("b", [_vm._v("“1. Servidores avaliados”")]),
                _vm._v(
                  " para analisar o desempenho individual de cada servidor. "
                ),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(" Recomenda-se visitar a aba "),
                _c("b", [_vm._v("“2. Relatórios gerenciais”")]),
                _vm._v(" para analisar o desempenho conjunto das unidades. "),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(" Recomenda-se visitar a aba "),
                _c("b", [_vm._v("“3. Relatórios gerenciais por unidade”")]),
                _vm._v(
                  " para analisar o desempenho conjunto dos servidores da unidade. "
                ),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(
                  " O Gestor pode trabalhar os dados expostos, por meio dos gráficos e tabelas, com sua equipe no intuito de verificar os talentos da unidade e direcionar as ações de desenvolvimento de competências comportamentais. "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }